module.exports = __webpack_public_path__ + "5c4586187cd40ae14a47b892aaae6cea.jpg";